// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f82hl","question":"styles_question__2wOY4","description":"styles_description__3dfBA"};